import { useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import ContactContext from 'contexts/contactContext'

interface Props {
  propertyName: string
  hasRateError: boolean
  checkIn?: string
  lowestAvailableStayPayTier?: App.StayPayTier | null
}

function PropertyRoomAvailabilityMessages({ propertyName, hasRateError, checkIn, lowestAvailableStayPayTier }: Props) {
  const intl = useIntl()
  const supportContact = useContext(ContactContext)

  return <>
    {hasRateError && <MessageBanner
      kind="warning"
      tabletAlign="center"
      heading={intl.formatMessage(
        {
          id: 'BnvLw0OFjcVH9KIHccT2',
          defaultMessage: 'The third party booking system for {propertyName} is currently down',
          description: 'Error message heading when property booking system is down',
        },
        { propertyName },
      )}
    >
      {intl.formatMessage(
        {
          id: 'tGbUfKIAF_biyC8JvkSw',
          defaultMessage: 'Please call our VIP team on {phoneNumber} who are ready to provide assistance to complete your booking',
          description: 'Error message body with phone number when property booking system is down',
        },
        { phoneNumber: supportContact.local.humanReadable },
      )}
    </MessageBanner>}
    {!checkIn && lowestAvailableStayPayTier && <MessageBanner
      kind="promotional"
      icon={<LineInfoCircleIcon />}
    >
      <FormattedMessage
        id="w_UoFwnNZR6UH1nCXBD5"
        defaultMessage="<b>Special offer:</b> Enjoy free nights for stays longer than {dayCountLabel}. Select dates to check eligibility."
        description="Stay pay tier promotional banner message in the loyalty section"
        values={{
          dayCountLabel: intl.formatMessage(
            {
              id: '--kBF6UkfAMNYHooUklh',
              defaultMessage: '{count, plural, one {# day} other {# days}}',
              description: 'Stay length day count label shown in special offer banner',
            },
            { count: lowestAvailableStayPayTier.stayNights },
          ),
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
    </MessageBanner>}
  </>
}

export default PropertyRoomAvailabilityMessages
